/* eslint-disable */
export enum FeatureFlagsEnum {
    MasteringPluginOnPricing = 'P_MasteringPluginOnPricing',
    FreeTrial = 'B_FreeTrial',
}
